import { useQuery } from "@apollo/client/react";

import { graphql } from "../../__generated__/gql";
import { OrganizationRole } from "../../__generated__/gql/graphql";

const Query = graphql(`
  query IsOrganizationManagerForGlobalMenu {
    maybeViewer {
      organizationMembership {
        role
      }
    }
  }
`);

export function useIsOrganizationManager() {
  const { data, loading } = useQuery(Query);
  return {
    isOrganizationManager:
      data?.maybeViewer?.organizationMembership?.role ===
      OrganizationRole.Admin,
    loading,
  };
}
